import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import i18next from 'i18next'
import { initReactI18next } from 'react-i18next'
import HttpApi from 'i18next-http-backend'
import LanguageDetector from 'i18next-browser-languagedetector'
import {BrowserRouter as Router} from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import 'react-modern-drawer/dist/index.css'
import 'react-toastify/dist/ReactToastify.css';
import './assets/scss/global.scss';
import { ErrorBoundary } from 'react-error-boundary';
import Error from './pages/error/error';
import {Provider} from 'react-redux'
import {store,persistor} from './store/index'
import { ToastContainer } from 'react-toastify';
import { PersistGate } from 'redux-persist/integration/react';
// import { createReactRouterV6Options, Faro, getWebInstrumentations, initializeFaro, ReactIntegration } from '@grafana/faro-react';
// import { TracingInstrumentation } from '@grafana/faro-web-tracing';
// import { createRoutesFromChildren, matchRoutes, Routes, useLocation, useNavigationType } from 'react-router-dom';
// import { getEnv } from '@helpers';
// import packageJson from '../package.json'

// let faro:Faro;
// try {
//   faro = initializeFaro({
//     url: 'https://faro-collector-prod-eu-west-2.grafana.net/collect/7867b56b7ccff849a3c246703648a6b8',
//     app: {
//       name: 'ts-smartpay',
//       version: packageJson.version,
//       environment: getEnv()
//     },
    
//     instrumentations: [
//       // Mandatory, omits default instrumentations otherwise.
//       ...getWebInstrumentations(),
  
//       // Tracing package to get end-to-end visibility for HTTP requests.
//       new TracingInstrumentation(),
  
//       // React integration for React applications.
//        new ReactIntegration({
//         router: createReactRouterV6Options({
//           createRoutesFromChildren,
//           matchRoutes,
//           Routes,
//           useLocation,
//           useNavigationType,
//         }),
//       }),
//     ],
//   });
// } catch (error) {
//   // do nothing
// }

// export { faro };

// Create React root node
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

i18next
  .use(HttpApi)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    supportedLngs: ['en', 'ar', 'fr'],
    fallbackLng: 'en',
    debug: false,
    // Options for language detector
    detection: {
      order: ['localStorage','cookie','htmlTag','querystring', 'path' , 'sessionStorage', 'navigator', 'subdomain'],
      caches: ['localStorage'],
    },
    // react: { useSuspense: false },
    backend: {
      loadPath: '/locales/{{lng}}/translation.json',
      requestOptions:{
        cache:'no-store'
      }
    }
  })

root.render(
  //<React.StrictMode>
    <Router>
      <HelmetProvider>
        <Provider store={store}>
          <PersistGate persistor={persistor}>
            <ErrorBoundary FallbackComponent={Error}>
                <ToastContainer position="top-center" autoClose={3000} hideProgressBar={true} closeButton={false} />
                <Suspense>
                  <App />
                </Suspense>
            </ErrorBoundary>
          </PersistGate>
        </Provider>
      </HelmetProvider>
    </Router>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
